import { calcResize } from 'components/Layout/styles';
import DotSVG from 'components/DotSVG';
import styled from 'styled-components';

export const SSection = styled.section`
  background: ${props => props.theme.colors.main};
  padding: ${calcResize(60, 100)} 0;
  position: relative;
  overflow: hidden;
`;

export const STitle = styled.h2`
  color: ${props => props.theme.colors.pastel_blue};
`;

export const SDotSvg = styled(DotSVG)`
  top: 35px;
`;

export const SSubtitle = styled.p`
  color: #ffffff;
`;

export const SHref = styled.a`
  color: ${props =>
    props.$backgroundColor !== 'primary'
      ? '#ffffff'
      : props.theme.colors.primary};

  &:hover {
    color: ${props =>
      props.$backgroundColor !== 'primary'
        ? '#ffffff'
        : props.theme.colors.primary};
  }
`;
